import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7b5da26d from 'nuxt_plugin_plugin_7b5da26d' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_nuxtcookiecontrol_5e4bdbaf from 'nuxt_plugin_nuxtcookiecontrol_5e4bdbaf' // Source: ./nuxt-cookie-control.js (mode: 'all')
import nuxt_plugin_workbox_352d9513 from 'nuxt_plugin_workbox_352d9513' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_4f361926 from 'nuxt_plugin_metaplugin_4f361926' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_0d7a9c92 from 'nuxt_plugin_axios_0d7a9c92' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_57e7b5de from 'nuxt_plugin_axios_57e7b5de' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_global_91e20330 from 'nuxt_plugin_global_91e20330' // Source: ../plugins/global (mode: 'all')
import nuxt_plugin_fontawesome_4197a3ea from 'nuxt_plugin_fontawesome_4197a3ea' // Source: ../plugins/font-awesome (mode: 'all')
import nuxt_plugin_vuelidate_114556cc from 'nuxt_plugin_vuelidate_114556cc' // Source: ../plugins/vuelidate (mode: 'all')
import nuxt_plugin_auth0webauth_03821179 from 'nuxt_plugin_auth0webauth_03821179' // Source: ../plugins/auth0webauth (mode: 'all')
import nuxt_plugin_vmask_55a21606 from 'nuxt_plugin_vmask_55a21606' // Source: ../plugins/vmask (mode: 'all')
import nuxt_plugin_touchevents_d1ceab28 from 'nuxt_plugin_touchevents_d1ceab28' // Source: ../plugins/touch-events (mode: 'all')
import nuxt_plugin_vuelayers_1ab13498 from 'nuxt_plugin_vuelayers_1ab13498' // Source: ../plugins/vuelayers.js (mode: 'client')
import nuxt_plugin_socketio_1a094fdb from 'nuxt_plugin_socketio_1a094fdb' // Source: ../plugins/socket.io.js (mode: 'client')
import nuxt_plugin_loadscript_7dec522c from 'nuxt_plugin_loadscript_7dec522c' // Source: ../plugins/load-script.js (mode: 'all')
import nuxt_plugin_notifications_7d2ae283 from 'nuxt_plugin_notifications_7d2ae283' // Source: ../plugins/notifications (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","title":"Mosaic Airport Viewer","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=0"},{"hid":"description","name":"description","content":"Best Airport Viewer: Track live surface operations for airlines, airports and anyone wanting to see aircraft or vehicle movement on a map of the airport."},{"name":"keywords","content":"mosaic airport flight aircraft truck view track surface taxi status map"}],"script":[{"src":"https:\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js","async":true},{"src":"https:\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js","data-ad-client":"ca-pub-3171038478246380","async":true}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7b5da26d === 'function') {
    await nuxt_plugin_plugin_7b5da26d(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcookiecontrol_5e4bdbaf === 'function') {
    await nuxt_plugin_nuxtcookiecontrol_5e4bdbaf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_352d9513 === 'function') {
    await nuxt_plugin_workbox_352d9513(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_4f361926 === 'function') {
    await nuxt_plugin_metaplugin_4f361926(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0d7a9c92 === 'function') {
    await nuxt_plugin_axios_0d7a9c92(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_57e7b5de === 'function') {
    await nuxt_plugin_axios_57e7b5de(app.context, inject)
  }

  if (typeof nuxt_plugin_global_91e20330 === 'function') {
    await nuxt_plugin_global_91e20330(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_4197a3ea === 'function') {
    await nuxt_plugin_fontawesome_4197a3ea(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_114556cc === 'function') {
    await nuxt_plugin_vuelidate_114556cc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth0webauth_03821179 === 'function') {
    await nuxt_plugin_auth0webauth_03821179(app.context, inject)
  }

  if (typeof nuxt_plugin_vmask_55a21606 === 'function') {
    await nuxt_plugin_vmask_55a21606(app.context, inject)
  }

  if (typeof nuxt_plugin_touchevents_d1ceab28 === 'function') {
    await nuxt_plugin_touchevents_d1ceab28(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelayers_1ab13498 === 'function') {
    await nuxt_plugin_vuelayers_1ab13498(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socketio_1a094fdb === 'function') {
    await nuxt_plugin_socketio_1a094fdb(app.context, inject)
  }

  if (typeof nuxt_plugin_loadscript_7dec522c === 'function') {
    await nuxt_plugin_loadscript_7dec522c(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_7d2ae283 === 'function') {
    await nuxt_plugin_notifications_7d2ae283(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
